(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lwc-collection-featured"] && !Shopify.designMode) return;
  try {
    (function () {
    var LABELS = { f: "Front", b: "Back", d: "Side", s: "Side", omf: "On model, front", oms: "On model, side", omb: "On model, back" };
    function codeOf(url) {
      var m = /\/(\d+)_[a-z]+_[^/]*$/i.exec((url || "").split("?")[0]);
      return m ? m[1] : null;
    }
    function sized(url, w) {
      return url.replace(/([?&])width=\d+/, "$1width=" + w);
    }
    function setMain(panel, url) {
      var img = panel.querySelector("[data-lwc-card-img] > img");
      if (!img || !url) return;
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      img.src = sized(url, 900);
    }
    function render(panel, code, name, mainUrl, activeDot) {
      var cap = panel.querySelector("[data-lwc-colour-name]");
      if (name) name = name.replace(/\s*\/\s*/g, " / ").trim();
      if (cap) {
        var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
        var dots = Array.prototype.slice.call(panel.querySelectorAll("[data-lwc-swatch]"));
        var pressed = activeDot || panel.querySelector('[data-lwc-swatch][aria-pressed="true"]');
        var idx = dots.indexOf(pressed) + 1;
        var total = parseInt(cap.getAttribute("data-lwc-colour-total"), 10) || dots.length;
        cap.innerHTML = name
          ? "<b>" + esc(name) + "</b>" + (idx > 0 && total > 1 ? "<span>" + idx + " of " + total + " colours</span>" : "")
          : "";
      }
      var box = panel.querySelector("[data-lwc-angles]");
      if (!box) return;
      var list = (panel.__lwcAngles || []).filter(function (a) { return a[0] === code; });
      box.innerHTML = "";
      var gallery = panel.querySelector("[data-lwc-gallery]");
      var layout = gallery ? gallery.getAttribute("data-lwc-angle-layout") : "";
      if (layout === "tiles" || layout === "mirror") {
        var mainFile = (mainUrl || "").split("?")[0].split("/").pop();
        var ORDER = ["b", "d", "s", "oms", "omb", "f", "omf"];
        var extra = list
          .filter(function (a) { return a[2].split("?")[0].split("/").pop() !== mainFile; })
          .sort(function (x, y) {
            var ix = ORDER.indexOf(x[1]), iy = ORDER.indexOf(y[1]);
            return (ix < 0 ? 99 : ix) - (iy < 0 ? 99 : iy);
          })
          .slice(0, layout === "mirror" ? 1 : 2);
        gallery.classList.toggle("lwc-feature__gallery--single", extra.length === 0);
        extra.forEach(function (a) {
          var t = document.createElement("div");
          t.className = "lwc-feature__tile";
          var im = document.createElement("img");
          im.src = sized(a[2], 600);
          im.alt = (LABELS[a[1]] || "Another view") + (name ? " – " + name : "");
          im.loading = "lazy";
          t.appendChild(im);
          box.appendChild(t);
        });
        return;
      }
      if (list.length < 2) return;
      var current = codeOf(mainUrl) === code ? (mainUrl || "").split("?")[0].split("/").pop() : null;
      list.forEach(function (a, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "lwc-feature__angle";
        var file = a[2].split("?")[0].split("/").pop();
        var pressed = current ? file === current : i === 0;
        b.setAttribute("aria-pressed", pressed ? "true" : "false");
        b.setAttribute("aria-label", (LABELS[a[1]] || "View " + (i + 1)) + (name ? " – " + name : ""));
        var im = document.createElement("img");
        im.src = sized(a[2], 160);
        im.alt = "";
        im.loading = "lazy";
        b.appendChild(im);
        b.addEventListener("click", function () {
          setMain(panel, a[2]);
          box.querySelectorAll(".lwc-feature__angle").forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        });
        box.appendChild(b);
      });
    }
    function init(panel) {
      if (panel.__lwcGalleryWired) return;
      panel.__lwcGalleryWired = true;
      try {
        panel.__lwcAngles = JSON.parse(panel.querySelector("[data-lwc-angle-data]").textContent);
      } catch (e) {
        panel.__lwcAngles = [];
      }
      var first = panel.querySelector('[data-lwc-swatch][aria-pressed="true"]') || panel.querySelector("[data-lwc-swatch]");
      if (first) {
        var url = first.getAttribute("data-lwc-image");
        var code = codeOf(url);
        if (url) setMain(panel, url);
        render(panel, code, first.getAttribute("aria-label"), url, first);
      }
    }
    function initAll() {
      document.querySelectorAll(".lwc-feature").forEach(init);
    }
    document.addEventListener("click", function (evt) {
      var btn = evt.target.closest && evt.target.closest("[data-lwc-swatch]");
      if (!btn) return;
      var panel = btn.closest(".lwc-feature");
      if (!panel) return;
      var url = btn.getAttribute("data-lwc-image");
      render(panel, codeOf(url), btn.getAttribute("aria-label"), url, btn);
    });
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
    else initAll();
    document.addEventListener("shopify:section:load", initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
